<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex burger-spacing justify-content-between mb-3">
        <back-arrow :title="user.firstname + ' ' + user.lastname "/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form @submit.stop.prevent="clickOnValidateBtn">

              <div class="row">

                <!-- nom -->
                <div class="col-md-6">
                  <string-field
                    :label="$t('user.Lastname') + ' *'"
                    :id="'lastname-input'"
                    :input-value="this.form.lastname"
                    v-model="this.form.lastname"
                    :is-required="true">
                  </string-field>
                </div>

                <!-- prénom -->
                <div class="col-md-6">
                  <string-field
                    :label="$t('user.Firstname') + ' *'"
                    :id="'firstname-input'"
                    :input-value="this.form.firstname"
                    v-model="this.form.firstname"
                    :is-required="true">
                  </string-field>
                </div>

                <!-- email -->
                <div class="col-md-6">
                  <string-field
                    :label="$t('user.Username') + ' *'"
                    :id="'username-input'"
                    :input-value="this.form.username"
                    v-model="this.form.username"
                    :type="'email'"
                    :is-required="true"
                    :is-disabled = true>
                  </string-field>
                </div>

                <!-- téléphone -->
                <div class="col-md-6">
                  <phone-number-field
                    :phone-number="this.form.phoneNumber"
                    v-model="this.form.phoneNumber">
                  </phone-number-field>
                </div>

              </div>

              <div class="d-flex justify-content-end">
                <b-button type="submit" variant="primary">
                  <span v-if="!isLoading">{{ $t('Validate') }}</span>
                  <b-spinner v-else :label="$t('spinner.isLoading')" small></b-spinner>
                </b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import api from '../../services/api'
import i18n from '../../i18n'
import BackArrow from "../../components/b122/BackArrow.vue"
import PhoneNumberField from "../../components/b122/editFields/PhoneNumberField.vue";
import StringField from "../../components/b122/editFields/StringField.vue";

export default {

  name: 'AccountEdit',
  components: {StringField, PhoneNumberField, BackArrow},

  data () {
    return {

      userId: this.$store.getters.userId,
      user: {},
      isLoading: false,
      form: {
        firstname:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lastname:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        username:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        phoneNumber:
          {
            state: null,
            invalidFeedback: null,
            value: null,
            formattedNumber: null,
            countryCode: null
          }
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {

    async fetchData () {
      this.fetchUser()
    },

    fetchUser () {
      api
        .get(`/account/getAccount`)
        .then(response => {
          this.user = response.data
          this.setInitialValues()
        })
        .catch((error) => {
          this.$router.push({
            name: '/',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    setInitialValues () {
      this.form.firstname.value = this.user.firstname
      this.form.lastname.value = this.user.lastname
      this.form.username.value = this.user.username
      this.form.phoneNumber.value = this.user.phoneNumber
      this.form.phoneNumber.countryCode = this.user.phoneCountryCode
    },

    clickOnValidateBtn () {
      this.onSubmit()
    },

    onSubmit () {

      this.isLoading = true

      let data = new FormData()
      data.append('firstname', this.form.firstname.value)
      data.append('lastname', this.form.lastname.value)
      data.append('username', this.form.username.value)
      data.append('phoneNumber', this.form.phoneNumber.formattedNumber)
      data.append('phoneCountryCode', this.form.phoneNumber.countryCode)

      api({
        method: 'POST',
        url: `/account/updateAccount`,
        data: data
      })
        .then(() => {
          this.$router.push({
            name: 'AccountShow'
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.username.value)
            })
          })
        })
        .catch((error) => {
          this.isLoading = false
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: '/',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = i18n.t(error.response.data.message)
          }
        })
    },

    successToast (userName) {
      this.$bvToast.toast(this.$i18n.t('User') + ' "' + userName + '" ' + this.$i18n.t('modified'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/account/AccountEdit.vue